import { exerciseTypeFromEnum } from "@/lib/puzzles";
import type { PlayProps } from "@/types/puzzle";
import MultipleChoicePlay from "./MultipleChoicePlay";
import FillInTheBlankPlay from "./FillInTheBlankPlay";
import ReorderWordsPlay from "./ReorderWordsPlay";
import MatchPairsPlay from "./MatchPairsPlay";
import TranslateSentencePlay from "./TranslateSentencePlay";
import StrokeOrderPlay from "./StrokeOrderPlay";

interface Props {
  exerciseType: string;
  data: Record<string, unknown>;
  onAnswer: (a: unknown) => void;
  result: PlayProps["result"];
}

export default function ExerciseRenderer({ exerciseType, data, onAnswer, result }: Props) {
  const type = exerciseTypeFromEnum(exerciseType);
  const playProps: PlayProps = { data, onAnswer, result };

  const content = (() => {
    switch (type) {
      case "multiple-choice":
        return <MultipleChoicePlay {...playProps} />;
      case "fill-in-the-blank":
        return <FillInTheBlankPlay {...playProps} />;
      case "reorder-words":
        return <ReorderWordsPlay {...playProps} />;
      case "match-pairs":
        return <MatchPairsPlay {...playProps} />;
      case "translate-sentence":
        return <TranslateSentencePlay {...playProps} />;
      case "stroke-order":
        return <StrokeOrderPlay {...playProps} />;
      default:
        return null;
    }
  })();

  return <div className="animate-slide-in-right">{content}</div>;
}
